import React, { SyntheticEvent, useEffect, useState } from "react";
import {
  isOperationPermitted,
  showIcons,
} from "../../helpers/action-permission-helper";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import { formatMessage } from "../../translations/format-message";
import { FormattedMessage } from "react-intl";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import Grid from "../../shared-components/Grid/Grid";
import Pagination from "../../shared-components/Grid/Pagination";
import no_user from "../../assets/Images/svg/no-user.svg";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../models/ICommon";
import { useStore } from "../../contexts/StoreProvider";
import { observer } from "mobx-react";
import userSettingEnum from "../../constants/user-setting-enum";
import { ActionFormatter } from "../../shared-components/Grid/GridFormatter";
import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import systemModuleEnum from "../../constants/system-module-enum";
import toast from "react-hot-toast";
import AddEditFotaMzlForm from "./components/add-edit-fota-mzl";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import userTypeEnum from "../../constants/user-type-enum";
import { getUserTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import SlidingPanel from "react-sliding-side-panel";
import FotaMzlDetails from "./components/fota-mzl-detail";
import fotaFileTypeEnum from "../../constants/fota-file-type-enum";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import config from "../../helpers/config-helper";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";

const appConfig = config();

const FotaMzl = (props: any) => {
  const { preferencesStore, fotaMzlStore } = useStore();
  const { GetFotaMzlReleaseListService, fotaMzlReleaseList, addUpdateFotaMzlState, getFotaMzlList, 
    resetAddUpdateFotaMzlState, error, inProgress, reset, resetFotaMzlReleaseState, setIsModemView, 
    DeleteFotaMzlService, resetDeleteFotaMzlState, deleteFotaMzlState } = fotaMzlStore;
  const { userSetting, setUserSetting, islanguageChanged, updateLanguageChangedFlag } = preferencesStore;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [modemView, setModemView] = useState<boolean>(
    localStorage.getItem('mzl_is_modem_view') == "false" ? false : true
  );
  const [isViewChanged, setisViewChanged] = useState(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const modemJetViewToggleHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setModemView(!modemView);
    let tempModemView =
      localStorage.getItem('mzl_is_modem_view') == "false" ? true : false;
    setIsModemView(tempModemView);
    setModemView(tempModemView);
    setisViewChanged(true);
  };

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: fotaMzlReleaseList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };

  /**
   * This function calls the "GetFotaMzlReleaseListService" store funtion that get fota release list from API
   */
  const callGetFotaListService = () => {
    GetFotaMzlReleaseListService(modemView, pageInfo.currentPage, pageLimitInfo.pageLimit);
  };

  /**
   * This function shows the add group pop up from where we can add new group and update existing group prootcol. we use id to identify
   * that we are adding or updating group.
   * "Id == -1" : we are adding new group
   * "Id != -1" : means we are updating existing group
   */
  const openAddPopupHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    DeleteFotaMzlService(selectedId, modemView);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: fotaMzlReleaseList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFotaMzlList]);

  useEffect(() => {
    callGetFotaListService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isViewChanged) {
      callGetFotaListService();
      setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true, isPagerChange: true });
      setisViewChanged(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isViewChanged]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFotaMzlState.success) {
      toast.success(formatMessage("deleted_success"));
      resetDeleteFotaMzlState();
      props.deletePopupToggleHandler();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaMzlState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaError" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFotaMzlState.error) {
      toast.error(formatMessage(deleteFotaMzlState.error));
      resetDeleteFotaMzlState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaMzlState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFotaMzlState.success) {
      resetAddUpdateFotaMzlState();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFotaMzlState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const closePanelhandler = () => {
    resetFotaMzlReleaseState();
    setOpenPanel(false);
    setSelectedId(0);
    setSelectedRow({});
    // tenantStore.reset();
  };

  const actionIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isEdit",
        handler: openAddPopupHandler,
        icon: faPencilAlt,
        isDisable: true,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
    ],
    systemModuleEnum.Fota
  );

  const columns: any = [
    // {
    //   dataField: "UpdatedDate",
    //   text: formatMessage("created_date"),
    //   formatter: (cell: boolean, row: any) => {
    //     return (
    //       <>
    //         {cell}
    //         {(row.IsFotaReleaseApplied && getUserTypeFromLocalStorage() == userTypeEnum.TenantUser) &&
    //           <span className="ms-2" title={formatMessage("fota_applied")}>
    //             <img src={isActiveImgSrc} className="buttonIcon is_active_btn" />
    //           </span>
    //         }
    //       </>
    //     )
    //   },
    // },
    {
      dataField: "Version",
      text: formatMessage("version"),
    },
    {
      dataField: "EffectiveDateTimestamp",
      text: formatMessage("effective_date"),
    },
    {
      dataField: "FileType",
      text: formatMessage("file_type"),
      formatter: (cell: any, row: any) => {
        return (
          <>
            <span>{fotaFileTypeEnum[cell]}</span>
          </>
        )
      }
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "",
      formatter: ActionFormatter(actionIcons),
      text: formatMessage("actions"),
      hidden: (actionIcons.length === 0 || getUserTypeFromLocalStorage() == userTypeEnum.SystemUser) ? false : true,
    },
  ];

  return (
    <>
      {props.showAddPopup && (
        <AddEditFotaMzlForm
          id={selectedId}
          isModemView={modemView}
          modalClosed={props.addToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_fota"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_fota_confirm"
          isLoading={deleteFotaMzlState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area">
                  <ul className="d-flex align-items-center">
                    <li>
                      {/* { getUserTypeFromLocalStorage() == userTypeEnum.SystemUser &&
                          <span className="ms-1">(<FormattedMessage id={modemView ? "modem" : "jet"} />)</span>
                        } */}

                      {getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ?
                        <div className="form-check fotaTabs-switch ">
                          <input
                            className="ms-1 form-check-input"
                            type="checkbox"
                            role="switch"
                            data-testid="SwitchConfigurationView"
                            checked={modemView}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              closePanelhandler();
                              modemJetViewToggleHandler(e);
                            }}
                            id="flexSwitchCheckDefault"
                          />
                          <label htmlFor="flexSwitchCheckDefault">
                            <span title={formatMessage('modem')}>
                              <svg id="Layer_1" fill="currentColor" enableBackground="new 0 0 512 512" height="18px" viewBox="0 0 512 512" width="18px"><g id="XMLID_493_">
                                <path id="XMLID_582_" d="M66.707,93.022c-2.006-8.037-10.146-12.921-18.187-10.92c-8.038,2.007-12.926,10.149-10.919,18.188   l35.857,143.613h30.921L66.707,93.022z" />
                                <path id="XMLID_584_" d="M454.5,244.043l35.892-143.754c2.007-8.038-2.882-16.181-10.919-18.188   c-8.04-2.004-16.18,2.882-18.187,10.92l-37.672,150.881H449.5C451.178,243.903,452.845,243.952,454.5,244.043z" />
                                <path id="XMLID_598_" d="M449.5,273.903h-389c-33.36,0-60.5,27.141-60.5,60.5v64.444c0,16.267,13.234,29.5,29.5,29.5h451   c16.266,0,29.5-13.233,29.5-29.5v-64.444C510,301.044,482.86,273.903,449.5,273.903z M87.223,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S95.507,367.676,87.223,367.676z M131.667,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S139.951,367.676,131.667,367.676z M176.112,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S184.396,367.676,176.112,367.676z M414.928,367.676h-64.373   c-8.284,0-15-6.716-15-15s6.716-15,15-15h64.373c8.284,0,15,6.716,15,15S423.212,367.676,414.928,367.676z" />
                              </g>
                              </svg>
                              <FormattedMessage id="modem" />
                            </span>

                            <span title={formatMessage('jet')}>
                              <svg fill="currentColor" height="16px" width="16px" viewBox="0 0 512 512" role="img"><g><circle cx="391.5" cy="288.655" r="18.734" /><path d="m512 202.407h-209.638c-6.342 19.553-24.723 33.734-46.362 33.734-26.872 0-48.734-21.862-48.734-48.734 0-21.639 14.181-40.02 33.734-46.362v-141.045h-105.5v176.983c19.553 6.342 33.734 24.723 33.734 46.362 0 26.872-21.862 48.734-48.734 48.734s-48.734-21.862-48.734-48.734c0-21.639 14.181-40.02 33.734-46.362v-176.983h-105.5v309.593h209.638c6.342-19.553 24.723-33.734 46.362-33.734 26.872 0 48.734 21.862 48.734 48.734 0 21.639-14.181 40.02-33.734 46.362v141.045h105.5v-176.983c-19.553-6.342-33.734-24.723-33.734-46.362 0-26.872 21.862-48.734 48.734-48.734s48.734 21.862 48.734 48.734c0 21.639-14.181 40.02-33.734 46.362v176.983h105.5z" /><path d="m338.514 86.203c0 10.331 8.404 18.735 18.734 18.735s18.734-8.404 18.734-18.735c0-10.33-8.404-18.734-18.734-18.734s-18.734 8.404-18.734 18.734z" /><path d="m271 141.045c14.825 4.808 26.554 16.537 31.362 31.362h209.638v-71.204h-108.39c-6.342 19.554-24.723 33.735-46.362 33.735-26.872 0-48.734-21.862-48.734-48.735 0-26.872 21.862-48.734 48.734-48.734 21.639 0 40.02 14.181 46.362 33.734h108.39v-71.203h-241z" /><path d="m241 370.955c-14.825-4.808-26.554-16.537-31.362-31.362h-209.638v71.204h108.389c6.342-19.554 24.723-33.735 46.363-33.735 26.872 0 48.734 21.862 48.734 48.735 0 26.872-21.862 48.734-48.734 48.734-21.64 0-40.021-14.181-46.363-33.734h-108.389v71.203h241z" /><circle cx="120.5" cy="223.345" r="18.734" /><circle cx="256" cy="187.407" r="18.734" /><path d="m173.486 425.797c0-10.331-8.404-18.735-18.734-18.735-10.331 0-18.735 8.404-18.735 18.735 0 10.33 8.404 18.734 18.735 18.734 10.33 0 18.734-8.404 18.734-18.734z" /><circle cx="256" cy="324.593" r="18.734" /></g></svg>
                              <FormattedMessage id="jet" />
                            </span>
                          </label>
                        </div> :
                        <p className="h5 ps-5 mb-0">
                          <FormattedMessage id="fota_title" />
                        </p>
                      }
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
                      <li title={formatMessage("fota_add")}>
                        <LoaderButton
                          id="fotaUpdateModal"
                          text="fota_add"
                          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => openAddPopupHandler({ Id: -1 }, e)}
                        />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table_items_list">
        {inProgress && <FormLoader loading={inProgress} />}
        {(getFotaMzlList.length) > 0 ? (
          <div
            className={`card mt-3 changingPanel ${openPanel ? "panelOpen" : ""
              }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                <Grid
                  data={getFotaMzlList}
                  columns={columns}
                  keyField="Id"
                  loading={inProgress}
                  rowEvents={{ onClick: rowEvents }}
                  rowClasses={rowClassFormat}
                />
              </div>
            </div>

            {(getFotaMzlList.length > 0) ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_update_history" />
            </p>
            <p className="mb-3">{formatMessage("no_fota_history_msg")}</p>
            {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
              <LoaderButton
                text="fota_add"
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => openAddPopupHandler({ Id: -1 }, e)}
              />
            )}
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">
                {selectedRow.EffectiveDateTimestamp}
              </h2>
            </div>
            <div className="col-lg-1 text-end">
              <button onClick={closePanelhandler} className="Crossicons" title={formatMessage("close")}>
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <FotaMzlDetails isModemView={modemView} selectedData={selectedRow} />
        </div>
      </SlidingPanel>
    </>
  );
};

export default DeletePopupHOC(ShowPopupHOC(AddPopupHOC(observer(FotaMzl))));
